import { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions, DialogTitle } from "@mui/material";
import UploadPhotos from "./upload-photos";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import { styled } from '@mui/material/styles';
import { AiListingsCreationServ } from "../../../Services/AIListingCreation";
import { FeatureCard } from "./FeatureCard";
import { useNavigate, useLocation } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface Image {
    src: string
    id: number | string
    ext: string
    toAnalyze: boolean
}

const Url = process.env.REACT_APP_URl;

const StartUploading: React.FunctionComponent<{ OnUploadImages: any, onChangeTaps?: any, onShowMessageUpgrade: any, onChangehandler: any, data: any }> = (props) => {

    const [listImages, setListImages] = useState<Image[]>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isOpenProcessing, setIsOpenProcessing] = useState<boolean>(false);
    const [isOpenPhotosToAnalyze, setIsOpenPhotosToAnalyze] = useState<boolean>(false);
    const [selectAll, setSelectAll] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        if (!listImages) return;
        const allSelected = listImages.every(img => img.toAnalyze);
        setSelectAll(allSelected);
    }, [listImages]);

    const UploadImagesHandler = async (images: Image[], isOversized: boolean) => {
        setListImages(images);
        setIsOpenProcessing(false);
        setIsOpenPhotosToAnalyze(true);
        if (images.length === 0) {
            setIsOpen(isOversized);
            return;
        }
    };

    const toggleToAnalyze = (id: number | string, value?: boolean) => {
        setListImages(prev =>
            prev.map(img =>
                img.id === id
                    ? { ...img, toAnalyze: value !== undefined ? value : !img.toAnalyze }
                    : img
            )
        );
    };

    const handleChangeSelectAll = () => {
        const newSelectAll = !selectAll;
        setListImages(prev =>
            prev.map(img => ({
                ...img,
                toAnalyze: newSelectAll,
            }))
        );
        setSelectAll(newSelectAll);
    };

    const handleCloseDialog = () => {
        setIsOpenPhotosToAnalyze(false);
    };

    const StartProcessing = async () => {
        setIsOpenProcessing(true)
        try {
            const { processId } = await AiListingsCreationServ({ images: listImages });
            const eventSource = new EventSource(`${Url}/analysis_progress/${processId}`);
            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    setIsOpenPhotosToAnalyze(false);
                    setIsOpenProcessing(false);
                    if (data.error) {
                        props.onChangehandler(data.error, true, "error");
                        eventSource.close();
                        return;
                    }

                    if (data.images && data.images.length > 0) {
                        props.OnUploadImages(data, false);
                        const allAnalyzed = data.images
                            .filter((img: any) => img.toAnalyze === true)
                            .every((img: any) => img.analysisProgress === 100);

                        if (allAnalyzed) {
                            props.onChangehandler("All images analysis completed", true, "success");
                            eventSource.close();
                        }
                    }
                } catch (err) {
                    props.onChangehandler("SSE error occurred", true, "error");
                    eventSource.close();
                }
            };
            eventSource.onerror = () => {
                props.onChangehandler("SSE network or server error", true, "error");
                eventSource.close();
            };
        } catch (error: any) {
            if (error.response && error.response.status === 401) {
                props.onShowMessageUpgrade(error.response.data.message);
            } else {
                props.onChangehandler("Failed to upload images.", true, "error");
            }
        }
    }

    return (
        <>
            <div className="row mt-4 d-flex align-items-center justify-content-center ">
                <div className="col-md-10 position-relative header-title">
                    {location.pathname === "/Listing-Creation" ? (
                        <button className="buuton-next border-trans marg-left-16 bold-700 back-EEF2FF color-4F52C1 border-9 position-absolute end-0" onClick={() => props.onChangeTaps("TitleAndDescription")}>
                            Next
                        </button>
                    ) : <a className="buuton-next border-trans marg-right-16 back-EEF2FF border-9 position-absolute start-0" href="/properties" >
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                    }
                    <div className=" text-center">
                        <h1 className="title-24 mb-3">{props.data.title}</h1>
                        <p className="para-16 color-39393B">{props.data.description}</p>
                    </div>
                </div>
            </div>
            <div className="row d-flex justify-content-center mt-4">
                <div className="col-md-8 marg-bottom-30">
                    <UploadPhotos OnUploadImages={UploadImagesHandler} />
                    <p className="para-onest-16 color-727272 mt-4 text-center">{t("startUploading.uploadAdvice")}</p>
                </div>
                <div className="col-md-10">
                    <h2 className="title-24 title-20-mb mb-4">{t("startUploading.enhancementsTitle")}</h2>
                    <div className="card-container border-8 border-D1D5DB ">
                        {
                            props.data.features && props.data.features.map((feature: any, index: number) => (
                                <FeatureCard key={index} img={feature.img} label={feature.label} />
                            ))
                        }
                    </div>
                    <h1 className="title-24 title-20-mb mb-4">{t("startUploading.generateWithAi")}</h1>
                    <div className="card-container border-8 border-D1D5DB">
                        {
                            props.data.aiFeatures && props.data.aiFeatures.map((feature: any, index: number) => (
                                <FeatureCard key={index} img={feature.img} label={feature.label} />
                            ))
                        }
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent>
                    <p className="title-18 bold-500 line-height-30 color-000000 marg-bottom-0">
                        {t("startUploading.sizeLimit")}
                    </p>
                </DialogContent>
                <DialogActions>
                    <button type="button" className="button-dash border-4F52C1 color-4F52C1 back-trans padd-15" onClick={() => setIsOpen(false)}>
                        {t("startUploading.gotIt")}
                    </button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                open={isOpenPhotosToAnalyze}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseDialog();
                    }
                }}
                aria-labelledby="customized-dialog-title"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle sx={{ m: 0, px: 2, py: 3 }} id="customized-dialog-title">
                    <div className="title-20 marg-right-10 marg-left-10">Select Photos for enhancements recommendations</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div className="padd-10">

                        {/* Select All */}
                        <div className="form-check mb-3">
                            <input
                                id={`check-1`}
                                type="checkbox"
                                className="form-check-input"
                                name={`check-1`}
                                onChange={handleChangeSelectAll}
                                checked={selectAll}
                            />
                            <label className="form-check-label" htmlFor={`check-1`}>
                                Select All
                            </label>
                        </div>

                        {/* Images */}
                        {listImages?.length ? (
                            <div className="image-grid mb-3">
                                {listImages.map((image: Image, index: number) => (
                                    <div
                                        key={image.id + "_" + index}
                                        className="select-image-container"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => toggleToAnalyze(image.id)}
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={image.id + "_" + index}
                                            checked={image.toAnalyze}
                                            onChange={() => toggleToAnalyze(image.id)}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        <img
                                            src={image.src}
                                            className="image"
                                            alt={`uploaded-${index}`}
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div>No pictures</div>
                        )}
                        {/* Note for users */}
                        <div className="alert alert-info mt-4 para-16 padd-15 border-6" style={{ background: '#e8f4fd', color: '#1976d2', border: '1px solid #b6e0fe' }}>
                            {listImages.filter(img => img.toAnalyze).length} photos will get enhancement recommendations.
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className="d-flex justify-content-end w-100 padd-10">
                        <button
                            type="button"
                            className={`button-dash border-trans color-FFFFFF back-746AFF padd-15 ${isOpenProcessing ? 'disabled' : ''}`}
                            onClick={StartProcessing}
                            disabled={isOpenProcessing}>

                            {isOpenProcessing ? (
                                <>
                                    Processing...
                                </>
                            ) : (
                                'Continue'
                            )}
                        </button>
                    </div>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}

export default StartUploading;